import React, { useRef } from 'react';

import { Theme, styled } from '@mui/material/styles';

import { css } from '../../../styled';
import { colorsPalette } from '../../../theme';
import Select from '../../Select/Select';

const StyledSelect = ({ ...props }) => {
  const selectRef = useRef<HTMLDivElement>(null);

  return (
    <SelectWrapper ref={selectRef}>
      <CustomizedSelect
        anchorRef={selectRef}
        selectBtnCss={selectBtnCss}
        selectHeaderCss={selectHeaderCss}
        widthByAnchor
        {...props}
      />
    </SelectWrapper>
  );
};

export default StyledSelect;

const SelectWrapper = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  marginBottom: 24,
  borderRadius: '999em',
  background: colorsPalette.violetAnalyticsCard,
  justifyContent: 'space-around',
  width: '100%',
  padding: '5px 15px',
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    padding: '5px 35px',
  },
}));
const CustomizedSelect = styled(Select)`
  width: 100%;
`;
const selectBtnCss = css`
  width: 100%;
`;
const selectHeaderCss = css`
  width: 100%;
  justify-content: space-between;
`;
